// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a3d8307d","239":"511b0e82","640":"2534292d","732":"ed52a85f"}[chunkId] + ".chunk.js";
};